
  // Prevent Shopify/Dawn from auto-submitting the product form
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      form.setAttribute('data-type', 'custom'); // Optional: identifies this as custom
    });
  });


document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const headerWrapper = document.querySelector('.tanaka-header-wrapper');
  const isHome = headerWrapper && headerWrapper.getAttribute('data-template') === 'index';

  if (isHome) {
    body.classList.add('home');
  }

  // Elements
  const searchToggle = document.getElementById('searchToggle');
  const searchDropdown = document.getElementById('searchDropdown');
  const closeSearch = document.getElementById('closeSearch');

  const cartToggle = document.getElementById('cartToggle');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');

  const mobileToggle = document.getElementById('mobileMenuToggle');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileClose = document.getElementById('mobileDrawerClose');

  // Replace the cart close button with a new one
  const cartDrawerHeader = document.querySelector('.cart-drawer-header');
  const oldCloseCart = document.getElementById('closeCart');
  
  if (cartDrawerHeader && oldCloseCart) {
    // Remove the old button
    oldCloseCart.remove();
    
    // Create a new button with enhanced styling and functionality
    const newCloseCart = document.createElement('button');
    newCloseCart.id = 'closeCart';
    newCloseCart.className = 'close-button';
    newCloseCart.setAttribute('aria-label', 'Close cart');
    newCloseCart.innerHTML = '&times;';
    newCloseCart.style.cssText = `
      background: none;
      border: none;
      font-size: 2.5rem;
      cursor: pointer;
      line-height: 1;
      padding: 5px 10px;
      color: #777;
      z-index: 10005;
      position: relative;
      display: block;
    `;
    
    // Add the new button
    cartDrawerHeader.appendChild(newCloseCart);
    
    // Add event listener
    newCloseCart.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('New close cart button clicked');
      cartDrawer.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Improved success message implementation
  // Remove any existing success toast
  const existingToast = document.querySelector('.add-to-cart-toast');
  if (existingToast) existingToast.remove();
  
  // Create new success toast with better positioning and behavior
  const successToast = document.createElement('div');
  successToast.className = 'add-to-cart-toast';
  successToast.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 20px;
    background: #0faa61;
    color: white;
    padding: 10px 20px;
    font-weight: 600;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    z-index: 9990;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  `;
  successToast.textContent = 'Item added to cart!';
  document.body.appendChild(successToast);
  
  // Define the show toast function
  window.showToast = function() {
    successToast.style.opacity = '1';
    
    // Automatically hide after delay
    setTimeout(() => {
      successToast.style.opacity = '0';
    }, 2000);
  };

  // Scroll behavior
  function handleScroll() {
    if (window.scrollY > 10) {
      if (isHome) headerWrapper.classList.add('scrolled');
    } else {
      if (isHome) headerWrapper.classList.remove('scrolled');
    }
  }

  // Search
  function openSearch(e) {
    if (e) e.stopPropagation();
    searchDropdown.classList.add('visible');
    setTimeout(() => {
      const searchInput = searchDropdown.querySelector('input');
      if (searchInput) searchInput.focus();
    }, 100);
  }

  function closeSearchDropdown() {
    searchDropdown.classList.remove('visible');
  }

  // Cart
  function openCart() {
    cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    updateCart();
  }

  function closeCartDrawer() {
    console.log('Closing cart drawer');
    cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  // Mobile menu
  function openMobileMenu() {
    mobileDrawer.classList.add('open');
    mobileToggle.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileDrawer.classList.remove('open');
    mobileToggle.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Add a fallback format money function in case Shopify's isn't available
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents);
    }
    
    // Simple fallback formatter
    return '$' + (cents / 100).toFixed(2);
  }

// Replace your existing updateCartItem function with this fixed version:

function updateCartItem(variantId, quantity) {
  // 1. INSTANT UI UPDATE - Update the display immediately for better UX
  const cartLineItem = document.querySelector(`[data-variant-id="${variantId}"]`);
  let oldQuantity = 1;
  
  if (cartLineItem) {
    const quantityInput = cartLineItem.querySelector('.quantity-input');
    oldQuantity = parseInt(quantityInput.value);
    
    // Update the input immediately for instant feedback
    quantityInput.value = quantity;
    
    // Add loading state to the buttons
    const increaseBtn = cartLineItem.querySelector('.quantity-increase');
    const decreaseBtn = cartLineItem.querySelector('.quantity-decrease');
    const removeBtn = cartLineItem.querySelector('.remove-button');
    
    // Disable and dim buttons during update
    [increaseBtn, decreaseBtn, removeBtn].forEach(btn => {
      if (btn) {
        btn.style.opacity = '0.5';
        btn.disabled = true;
      }
    });
  }

  // 2. SINGLE API CALL - Much faster than double call
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    // Update cart count immediately
    const cartCount = document.getElementById('cartCount');
    if (cartCount) {
      cartCount.textContent = cart.item_count || 0;
    }
    
    // Update subtotal immediately
    const cartSubtotal = document.getElementById('cart-subtotal-price');
    if (cartSubtotal) {
      cartSubtotal.textContent = formatMoney(cart.total_price);
    }
    
    // If item was removed (quantity = 0) or something went wrong, do full re-render
    if (quantity === 0 || !cart.items.find(item => item.variant_id.toString() === variantId.toString())) {
      renderCartDrawerItems(cart);
    } else if (cartLineItem) {
      // Otherwise just update the line item price (much faster)
      const updatedItem = cart.items.find(item => item.variant_id.toString() === variantId.toString());
      if (updatedItem) {
        const priceElement = cartLineItem.querySelector('.cart-item-price');
        if (priceElement) {
          // Show line total (price × quantity)
          priceElement.textContent = formatMoney(updatedItem.final_line_price);
        }
      }
    }
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    
    // Revert the UI changes on error
    if (cartLineItem) {
      const quantityInput = cartLineItem.querySelector('.quantity-input');
      quantityInput.value = oldQuantity; // Revert to old quantity
    }
  })
  .finally(() => {
    // Re-enable buttons
    if (cartLineItem) {
      const increaseBtn = cartLineItem.querySelector('.quantity-increase');
      const decreaseBtn = cartLineItem.querySelector('.quantity-decrease');
      const removeBtn = cartLineItem.querySelector('.remove-button');
      
      [increaseBtn, decreaseBtn, removeBtn].forEach(btn => {
        if (btn) {
          btn.style.opacity = '1';
          btn.disabled = false;
        }
      });
    }
  });
}

  // Render cart line items into the cart drawer with improved styling
  function renderCartDrawerItems(cart) {
    const cartItemsContainer = document.getElementById('cart-items');
    const cartEmpty = document.querySelector('.cart-empty');
    const cartSubtotal = document.getElementById('cart-subtotal-price');

    if (!cartItemsContainer) return;
    
    // Add cart item styling if it doesn't exist yet
    if (!document.getElementById('cart-items-style')) {
      const cartStyle = document.createElement('style');
      cartStyle.id = 'cart-items-style';
      cartStyle.textContent = `
        .cart-line-item {
          display: grid;
          grid-template-columns: 100px 1fr auto;
          grid-gap: 20px;
          align-items: center;
          margin-bottom: 28px;
          position: relative;
        }
        
        .cart-item-image {
          width: 100px;
          height: 120px;
          object-fit: cover;
          background-color: #f8f8f8;
        }
        
        .cart-item-details {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        
        .cart-item-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin: 0 0 4px 0;
          color: #000;
        }
        
        .cart-item-variant {
          font-size: 14px;
          color: #666;
          margin: 0 0 12px 0;
          text-transform: uppercase;
        }
        
        .cart-item-price {
          font-size: 16px;
          font-weight: 500;
          color: #000;
        }
        
        .cart-item-quantity {
          display: flex;
          align-items: center;
          border: 1px solid #ddd;
          border-radius: 0;
          height: 30px;
          width: 80px;
        }
        
        .quantity-button {
          background: transparent;
          border: none;
          width: 40px;
          height: 40px;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #333;
          padding: 0;
        }
        
        .quantity-input {
          width: 40px;
          border: none;
          text-align: center;
          font-size: 14px;
          padding: 0;
          background: transparent;
          -moz-appearance: textfield;
        }
        
        .quantity-input::-webkit-outer-spin-button,
        .quantity-input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        .remove-button {
          position: absolute;
          top: 0;
          right: 0;
          background: none;
          border: none;
          cursor: pointer;
          padding: 8px;
          color: #999;
        }
        
        .remove-button svg {
          width: 18px;
          height: 18px;
        }
        
        .cart-footer {
          margin-top: 20px;
          padding-top: 20px;
          border-top: 1px solid #eee;
        }
        
        .cart-subtotal {
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 20px;
        }
      `;
      document.head.appendChild(cartStyle);
    }
    
    cartItemsContainer.innerHTML = '';

    if (cart.item_count > 0) {
      if (cartEmpty) cartEmpty.style.display = 'none';

      cart.items.forEach(item => {
        const itemHTML = `
          <div class="cart-line-item" data-variant-id="${item.variant_id}">
            <img src="${item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : ''}" alt="${item.product_title}" class="cart-item-image" />
            
            <div class="cart-item-details">
              <p class="cart-item-title">${item.product_title}</p>
              ${item.variant_title ? `<p class="cart-item-variant">${item.variant_title}</p>` : ''}
              <p class="cart-item-price">${formatMoney(item.final_price)}</p>
            </div>
            
            <div class="cart-item-quantity">
              <button class="quantity-button quantity-decrease" data-variant-id="${item.variant_id}">−</button>
              <input type="number" class="quantity-input" value="${item.quantity}" min="1" aria-label="Quantity" readonly />
              <button class="quantity-button quantity-increase" data-variant-id="${item.variant_id}">+</button>
            </div>
            
            <button class="remove-button" data-variant-id="${item.variant_id}" aria-label="Remove item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
        `;
        cartItemsContainer.insertAdjacentHTML('beforeend', itemHTML);
      });

   // WITH THESE IMPROVED EVENT LISTENERS:
// Add event listeners for quantity buttons with double-click prevention
cartItemsContainer.querySelectorAll('.quantity-decrease').forEach(button => {
  button.addEventListener('click', function() {
    // Prevent double clicks
    if (this.disabled) return;
    
    const variantId = this.getAttribute('data-variant-id');
    const input = this.nextElementSibling;
    const currentQty = parseInt(input.value);
    
    if (currentQty > 1) {
      updateCartItem(variantId, currentQty - 1);
    }
  });
});

cartItemsContainer.querySelectorAll('.quantity-increase').forEach(button => {
  button.addEventListener('click', function() {
    // Prevent double clicks
    if (this.disabled) return;
    
    const variantId = this.getAttribute('data-variant-id');
    const input = this.previousElementSibling;
    const currentQty = parseInt(input.value);
    
    updateCartItem(variantId, currentQty + 1);
  });
});

cartItemsContainer.querySelectorAll('.remove-button').forEach(button => {
  button.addEventListener('click', function() {
    // Prevent double clicks
    if (this.disabled) return;
    
    const variantId = this.getAttribute('data-variant-id');
    updateCartItem(variantId, 0);
  });
});

      if (cartSubtotal) {
        cartSubtotal.textContent = formatMoney(cart.total_price);
      }
    } else {
      if (cartEmpty) cartEmpty.style.display = 'block';
    }
  }

  // Make this function globally available for use by the product-form patch
  window.renderCartDrawerItems = renderCartDrawerItems;

  // Fetch and update cart
  function updateCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        renderCartDrawerItems(cart);
        const cartCount = document.getElementById('cartCount');
        if (cartCount) {
          cartCount.textContent = cart.item_count || 0;
        }
      })
      .catch(error => {
        console.error('Error loading cart data:', error);
      });
  }

  // Make these functions globally available
  window.updateCart = updateCart;
  window.openCart = openCart;

// Add to Cart Intercept (prevents redirect) - ONLY for actual add-to-cart actions
document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
  // Skip forms that have already been processed
  if (form.hasAttribute('data-processed')) return;
  
  // ONLY intercept forms that have an actual "Add to Cart" button being clicked
  // Skip variant selection forms or other form submissions
  form.addEventListener('submit', function (e) {
    // Check if this was triggered by an actual add-to-cart button
    const submitButton = document.activeElement;
    const isAddToCartButton = submitButton && (
      submitButton.type === 'submit' || 
      submitButton.classList.contains('product-form__cart-submit') ||
      submitButton.textContent.toLowerCase().includes('add to cart') ||
      submitButton.textContent.toLowerCase().includes('add to bag')
    );
    
    // If it's not an add-to-cart button, let the form submit normally (variant selection)
    if (!isAddToCartButton) {
      return; // Don't prevent default - let variant selection work
    }
    
    // Only prevent default for actual add-to-cart actions
    e.preventDefault();

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => {
        showToast();   // Success message
        updateCart();  // Re-render cart
        openCart();    // Open drawer
      })
      .catch(err => {
        console.error('Add to cart failed:', err);
      });
  });
  
  // Mark as processed
  form.setAttribute('data-processed', 'true');
});

  // Event listeners
  window.addEventListener('scroll', handleScroll);

  if (searchToggle) {
    searchToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      openSearch();
    });
  }

  if (closeSearch) {
    closeSearch.addEventListener('click', function(e) {
      e.stopPropagation();
      closeSearchDropdown();
    });
  }

  document.addEventListener('click', (e) => {
    if (searchDropdown && searchDropdown.classList.contains('visible')) {
      if (!searchDropdown.contains(e.target) && e.target !== searchToggle) {
        closeSearchDropdown();
      }
    }
  });

  if (searchDropdown) {
    searchDropdown.addEventListener('click', (e) => e.stopPropagation());
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchDropdown && searchDropdown.classList.contains('visible')) closeSearchDropdown();
      if (cartDrawer) closeCartDrawer();
      if (mobileDrawer) closeMobileMenu();
    }
  });

  if (cartToggle) {
    cartToggle.addEventListener('click', openCart);
  }

  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', openMobileMenu);
  }

  if (mobileClose) {
    mobileClose.addEventListener('click', closeMobileMenu);
  }

  // Initial state
  handleScroll();
  updateCart();

  window.addEventListener('load', function () {
    document.documentElement.classList.remove('preload');
  });
  
  // Wait for the product-form component to be defined and patch it
  function patchProductForm() {
    if (!customElements.get('product-form')) return;
    
    // Get the original product form class
    const OriginalProductForm = customElements.get('product-form');
    
    // If we've already patched it, don't patch again
    if (customElements.get('patched-product-form')) return;
    
    // Create a patched version
    customElements.define(
      'patched-product-form',
      class PatchedProductForm extends OriginalProductForm {
        constructor() {
          super();
          
          // Override onSubmitHandler with our patched version
          this.form.removeEventListener('submit', this.onSubmitHandler);
          this.form.addEventListener('submit', this.patchedSubmitHandler.bind(this));
          
          // Set up our custom cart drawer reference
          this.customCartDrawer = document.getElementById('cartDrawer');
          this.customCartToggle = document.getElementById('cartToggle');
        }
        
        patchedSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
          
          this.handleErrorMessage();
          
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
          
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                // Handle errors
                if (typeof publish === 'function') {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                }
                this.handleErrorMessage(response.description);
                
                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }
              
              // THIS IS THE MODIFIED PART - Use custom cart drawer instead of redirect
              if (!this.cart) {
                console.log('Using custom cart drawer instead of redirecting');
                
                // Update cart count and open drawer
                window.showToast();
                window.updateCart();
                window.openCart();
                
                // Return early to prevent the redirect
                return;
              }
              
              // Handle original behavior for Dawn's cart
              const startMarker = typeof CartPerformance !== 'undefined' ? 
                CartPerformance.createStartingMarker('add:wait-for-subscribers') : null;
              
              if (!this.error && typeof publish === 'function') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                }).then(() => {
                  if (startMarker && typeof CartPerformance !== 'undefined') {
                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                  }
                });
              }
              
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      if (typeof CartPerformance !== 'undefined') {
                        CartPerformance.measure("add:paint-updated-sections", () => {
                          this.cart.renderContents(response);
                        });
                      } else {
                        this.cart.renderContents(response);
                      }
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else if (this.cart) {
                if (typeof CartPerformance !== 'undefined') {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                } else {
                  this.cart.renderContents(response);
                }
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
              
              if (typeof CartPerformance !== 'undefined') {
                CartPerformance.measureFromEvent("add:user-action", evt);
              }
            });
        }
      }
    );
    
    // Replace existing product forms with our patched version
    document.querySelectorAll('product-form').forEach(form => {
      // Create a new patched element
      const patchedForm = document.createElement('patched-product-form');
      
      // Copy attributes
      Array.from(form.attributes).forEach(attr => {
        patchedForm.setAttribute(attr.name, attr.value);
      });
      
      // Move children
      while (form.firstChild) {
        patchedForm.appendChild(form.firstChild);
      }
      
      // Replace in DOM
      if (form.parentNode) {
        form.parentNode.replaceChild(patchedForm, form);
      }
    });
  }

  // Try to patch product form
  patchProductForm();
  
  // Try again after a delay in case it hasn't loaded yet
  setTimeout(patchProductForm, 500);
  
  // Hide Dawn's cart notifications/drawers if they exist
  const style = document.createElement('style');
  style.textContent = `
    cart-notification, 
    cart-drawer:not(#cartDrawer) {
      display: none !important;
    }
  `;
  document.head.appendChild(style);
  
});
document.addEventListener('click', function(e) {
  console.log('=== CLICK DEBUG ===');
  // ... your existing debug code ...
});

// ADD THIS NEW CODE RIGHT HERE:
document.addEventListener('click', function(e) {
  // Check if it's a thumbnail button in a product form
  if (e.target.matches('button.thumbnail') || 
      e.target.closest('button.thumbnail') ||
      (e.target.tagName === 'BUTTON' && 
       e.target.type === 'submit' && 
       e.target.classList.contains('global-media-settings'))) {
    
    console.log('🚫 Preventing thumbnail submit');
    e.preventDefault();
    e.stopPropagation();
  }
});

// ADD THIS TO THE BOTTOM OF YOUR JAVASCRIPT FILE

// Fix the search input clear button
document.addEventListener('DOMContentLoaded', function() {
  const searchDropdown = document.getElementById('searchDropdown');
  
  if (searchDropdown) {
    const searchInput = searchDropdown.querySelector('input[type="search"], input[type="text"]');
    
    if (searchInput) {
      // OPTION 1: Completely remove the browser's clear button
      searchInput.setAttribute('type', 'text'); // Change from 'search' to 'text' to remove clear button
      
      // OR OPTION 2: If you want to change the X to "Clear" text instead:
      // (Uncomment the lines below and comment out the line above if you prefer this)
      
      /*
      // Create a custom clear button
      const customClear = document.createElement('button');
      customClear.textContent = 'Clear';
      customClear.style.cssText = `
        position: absolute;
        right: 50px;
        top: 50%;
        transform: translateY(-50%);
        background: #f0f0f0;
        border: 1px solid #ccc;
        padding: 4px 8px;
        font-size: 0.8rem;
        cursor: pointer;
        border-radius: 3px;
        color: #666;
      `;
      
      // Add click functionality to clear the input
      customClear.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        searchInput.value = '';
        searchInput.focus();
      });
      
      // Insert the custom clear button
      searchInput.parentNode.appendChild(customClear);
      
      // Hide the custom clear button when input is empty
      function toggleClearButton() {
        customClear.style.display = searchInput.value.length > 0 ? 'block' : 'none';
      }
      
      searchInput.addEventListener('input', toggleClearButton);
      toggleClearButton(); // Initial check
      */
    }
  }
});

// Also handle dynamically created search inputs
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType === 1) { // Element node
        const searchInputs = node.querySelectorAll ? node.querySelectorAll('input[type="search"]') : [];
        searchInputs.forEach(input => {
          input.setAttribute('type', 'text'); // Remove clear button
        });
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });

